module.exports = __webpack_public_path__ + "img/1.088abb77.png";